// extracted by mini-css-extract-plugin
export var resizer = "_gb-0";